import {Component} from "@angular/core";

@Component({
    selector: "fui-section",
    styleUrls: ["./section.component.scss"],
    templateUrl: "./section.component.html"
})
export class FUISectionComponent {
}
